module.exports = __webpack_public_path__ + "586774d5645b51ebc5a7d659a20844e9.png";